import { get, API_URL } from '../utils/api';

/**
 * Get rationing information for an account
 * @param {string} accountUuid - UUID of the account to fetch rationing data for
 * @returns {Promise<Object>} - Rationing data
 */
export const getRationingData = async (accountUuid) => {
  if (!accountUuid) {
    // console.error('Missing accountUuid parameter for getRationingData');
    return null;
  }

  try {
    const response = await get(`${API_URL}/rationing/account/${accountUuid}`);
    return response.data;
  } catch (error) {
    // console.error('Error fetching rationing data:', error);
    return null;
  }
}; 